import { FC } from 'react'

import { Section } from 'components/section'

import classes from './section-wrapper.module.css'

interface SectionWrapperProps {}

export const SectionWrapper: FCRC<SectionWrapperProps> = ({ children }) => {
  return (
    <Section className={classes.section} theme="withoutGap">
      {children}
    </Section>
  )
}
